<template>
	<div class="m-node-list">
		<ul class="flex-center">
			<li v-for="(item, i) in nodes" :key="i" :class="{'z-now': item.current}">
				<div class="dot flex-center">
					<i class="tf tf-check"></i>
				</div>
				<p>{{item.name}}</p>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			nodes: Array
		}
	};
</script>

<style lang="stylus" scoped>
	.m-node-list {
		padding-bottom: 24px;
		
		li {
			position: relative;
			
			&:nth-child(n+2) {
				margin-left: 120px;
				
				&:before {
					content: '';
					position: absolute;
					right: 100%;
					top: 13px;
					width: 120px;
					height: 2px;
					background: #25C0C2;
				}
			}
			
			&.z-now {
				.dot {
					background: #fff;
				}
				
				p {
					opacity: 1;
				}
				
				~ li {
					&:before {
						background: #ccc;
					}
				
					.dot {
						border-color: #ccc;
						background: #fff;
					}
				}
			}
			
			.dot {
				box-sizing: border-box;
				width: 28px;
				height: 28px;
				border: 2px solid #25C0C2;
				border-radius: 100%;
				font-size: 14px;
				color: #fff;
				background: #25C0C2;
			}
			
			p {
				position: absolute;
				left: 50%;
				top: 40px;
				font-size: 13px;
				white-space: nowrap;
				color: #fff;
				opacity: .7;
				transform: translate(-50%,0);
			}
		}
	}
</style>
